const ServiceProviderRegisterTableSearchConfig = [
	{
		title: 'Gae',
		dataSource: 'Gae',
		sortable: true,
		width: 150
	},
	{
		title: 'Material Code',
		dataSource: 'MaterialNumber',
		sortable: true,
		width: 250
	},
	{
		title: 'Material Description',
		dataSource: 'Description',
		sortable: true,
		width: 500
	},
	{
		title: 'Article Group',
		dataSource: 'GaeDenomination',
		width: 250
	}
]
export default ServiceProviderRegisterTableSearchConfig
